import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { BsFillTrash3Fill } from "react-icons/bs";

interface DeleteApplicationConfirmationProps {
  onDeleteConfirm: (id: number) => Promise<void>;
  id: number;
}

const DeleteApplicationConfirmation: React.FC<
  DeleteApplicationConfirmationProps
> = ({ onDeleteConfirm, id }) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleDeleteClick = () => {
    setShowModal(true);
  };

  const handleConfirm = () => {
    onDeleteConfirm(id);
    setShowModal(false);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <BsFillTrash3Fill
        style={{ color: "darkred", cursor: "pointer" }}
        onClick={() => {
          handleDeleteClick();
        }}
        title={"Obriši prijavu"}
      />

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Potvrdi brisanje prijave</Modal.Title>
        </Modal.Header>
        <Modal.Body>Jeste li sigurni da želite obrisati prijavu?</Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleClose}>
            Odustani
          </Button>
          <Button onClick={handleConfirm}>Obriši</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteApplicationConfirmation;
